<template>
    <div class="row align-items-top container-box horizontal">
        <div v-for="property in properties.slice(0, item_number)" class="col-12">
            <div class="item">
                <div class="row align-items-top">
                    <div class="col-5">
                        <a :href="property_route.replace('slug', property.translate.slug) + params" target="_blank" class="img" :style="'background-image: url(\'/storage/' + property.images[0].path + '\');'" :alt="property.translate.name" :title="property.translate.name"></a>
                    </div>
                    <div class="col-7">
                        <div class="budget text-color-green">{{__('pages.available')}}</div>
                        <a :href="property_route.replace('slug', property.translate.slug) + params" target="_blank"><h4 class="title" :title="property.translate.name">{{property.translate.name}}</h4></a>
                        <div class="address">{{property.public_address}}</div>
                        <div class="phone">{{property.phone}}</div>
                        <div class="price"><span>{{number_format(property.price)}}</span>{{' Ft' + __('pages.property.prices.from')}}</div>
                        <hr>
                        <div class="star">
                            <i class="fas fa-star"></i>
                            <span>({{ property.rate_total}}) <small>{{property.rate_count}} {{__('pages.opinion')}}</small></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['properties', 'item_number', 'property_route', 'params']
}
</script>